module.exports = __webpack_public_path__ + "img/objetivo_13.495b71ef.webp";